import React from 'react';
import styled from 'styled-components';
import github from '!!svg-inline-loader?classPrefix!src/assets/github.svg';
import steam from '!!svg-inline-loader?classPrefix!src/assets/steam.svg';
import envelopSolid from '!!svg-inline-loader?classPrefix!src/assets/envelope-solid.svg';

const Table = styled.table`
  display: inline-table;
  font-size: 0.75rem;
  color: var(--font-light-color) !important;
  text-align: left;

  td {
    padding: 0 0.25rem;
  }

  a {
    color: var(--font-light-color) !important;
  }
`;

const CenterLine = styled.div`
  position: relative;
  width: 100;
  text-align: center;

  &::before,
  &::after {
    position: absolute;
    top: 50%;
    width: calc(50% - 3rem);
    transform: translateY(-50%);
    height: 1px;
    background: rgba(0, 115, 0, 0.15);
    content: ' ';
  }
  &::before {
    left: 0;
  }
  &::after {
    right: 0;
  }
`;

const ConnectTable: React.FC = () => {
  return (
    <div className="text-center">
      <CenterLine>
        <span className="text-sm text-font-light font-title">HELP ME</span>
      </CenterLine>
      <Table>
        <tbody>
          <tr>
            <td>
              <span
                className="fill-current inline-block align-middle"
                dangerouslySetInnerHTML={{
                  __html: envelopSolid,
                }}
                style={{ width: '.75em', height: '1em' }}
              />
            </td>
            <td>
              <a href="mailto:means88.x@gmail.com">means88.x@gmail.com</a>
            </td>
          </tr>
          <tr>
            <td>
              <span
                className="fill-current inline-block align-middle"
                dangerouslySetInnerHTML={{
                  __html: github,
                }}
                style={{ width: '.75em', height: '1em' }}
              />
            </td>
            <td>
              <a href="https://github.com/Means88">Means88</a>
            </td>
          </tr>
          <tr>
            <td>
              <span
                className="fill-current inline-block align-middle"
                dangerouslySetInnerHTML={{
                  __html: steam,
                }}
                style={{ width: '.75em', height: '1em' }}
              />
            </td>
            <td>
              <a href="http://steamcommunity.com/id/means88/">means88</a>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default ConnectTable;
